import * as _ from "lodash";
import Vue from 'vue';

import LayerFiltersContainer from '../../../modules/filters/containers/layer-filters/layer-filters.container';
import store from '../../../store';
import {
    FILTERS_GET_VALUES,
    FILTERS_UPDATE_CONTROLS,
    FILTERS_UPDATE_VALUES
} from '../../../store/modules/filters/types';

import infoBoard from '../infoboard';
import Workspace from "../../workspaces";
import { ControlType, Item } from "../../workspaces/item";
import { SidebarButton } from "../sidebar/button.helper";

const worldMap = () => require('../map').default;

const Filter = (() => {
    let currentFilter = {};
    let filterOptions = [];
    let _render = (options, worldMap) => {
        if (!options.container) {
            options.container = document.getElementById('filter-container');
        }

        store.dispatch(FILTERS_UPDATE_CONTROLS, {
            options,
            type: options.type,
            currentMap: worldMap._id
        });

        const el = document.createElement('div');
        $(options.container).html(el);

        return new Vue({
            el,
            components: {
                'layer-filters': LayerFiltersContainer
            },
            store,
            data: {
                worldMap,
                options
            },
            methods: {
                onSubmit(values) {
                    if (options.onSubmit) {
                        options.onSubmit(values);
                    }

                    Workspace.addAction(new Item("#filter-container #btn-submit", '', ControlType.InputButton));
                },
                onCancel() {
                    close();
                },
                handleDropdownChange(payload) {
                    if (options.onValueChange) {
                        options.onValueChange(payload);
                    }
            }
            },
            template: `
                <layer-filters
                  :id="options.id"
                  :title="options.label"
                  :world="worldMap"
                  @submit="onSubmit($event)"
                  @close="onCancel()"
                  @dropdownChanged="handleDropdownChange"/>
                </layer-filters>
            `
        });
    };

    const create = (options, map = worldMap().getCurrent()) => {
        const idElement = `${options.type.toLowerCase().replace(/\ /gi, '')}_filter`;

        SidebarButton.controlActiveButton(idElement, "filter");

        infoBoard.toggleFilter(true, (options.direction || 'up'));
        if (currentFilter.id === options.id) return;
        currentFilter = options;

        filterOptions.push({
            _id: `filters-options-${worldMap().getCurrent()._id}`,
            opt: options
        });

        return _render(options, map);
    };

    const close = (direction = 'up') => {
        infoBoard.toggleFilter(false, direction);
    };

    const updateControls = (options, map = worldMap().getCurrent()) => {
        store.dispatch(FILTERS_UPDATE_CONTROLS, {
            options,
            type: options.type,
            currentMap: map._id
        });
    };

    const reloadFilters = (worldId = worldMap().getCurrent()._id, options) => {
        try {
            const filterId = currentFilter ? currentFilter.id : undefined;

            if (store.getters[FILTERS_GET_VALUES][filterId]) {
                const values = store.getters[FILTERS_GET_VALUES][filterId][worldId];
                const _optionFirst = filterOptions
                  .filter(x => x._id === `filters-options-${worldId}`)
                  .filter(x => x.opt.id === filterId);
                currentFilter = _optionFirst[0].opt;

                if (options) {
                    Object.keys(options).forEach(key => {
                        currentFilter[key] = options[key];
                    });
                }

                set(filterId, worldId, values);
            }
        } catch (err) {
            console.log('Error (reloadFilters): ', err);
        }
    };

    const copyFilters = (id) => {
        try {
            const filterId_0 = `filters-0`;
            const filterId = `filters-${id}`;
            if (store.getters[FILTERS_GET_VALUES][filterId_0]) {
                const values = _.cloneDeep(store.getters[FILTERS_GET_VALUES][filterId_0][0]);
                set(filterId, id, values);
            }
        } catch (err) {
            console.log('Error (copyFilters): ', err);
        }
    };

    const get = (id, worldId = worldMap().getCurrent()._id) => {
        try {
            return store.getters[FILTERS_GET_VALUES][id][worldId];
        } catch (err) {
            return {};
        }
    };

    const set = (id, worldId = worldMap().getCurrent()._id, values) => {
        try {
            store.dispatch(FILTERS_UPDATE_VALUES, {
                id,
                worldId,
                values
            });
            if (currentFilter.id) {
                _render(currentFilter, worldMap().get(worldId));
            }
            return get(id, worldId);
        } catch (err) {
            console.log(err);
        }
    };

    const isVisible = () => {
        return $('#filter-container').isVisible();
    };

    const has = (filterId, worldId = worldMap().getCurrent()._id) => {
        try {
            return !!store.getters[FILTERS_GET_VALUES][filterId][worldId];
        } catch (err) {
            return false;
        }
    };

    return {
        close,
        create,
        get,
        has,
        set,
        isVisible,
        reloadFilters,
        copyFilters,
        updateControls
    };
})();

export default Filter;



// WEBPACK FOOTER //
// ./src/scripts/core/filters/index.js